import { SET_SAVE_FOR_LATER_OFFLINE } from "../../types";

const setSaveForLaterOffline = (order, deleteOrder) => (dispatch) => {
  dispatch({ type: SET_SAVE_FOR_LATER_OFFLINE, order, deleteOrder });
};

export { setSaveForLaterOffline };
